<template>
<ConfirmModal
    :title="`Import Payroll Exposures`"
    :action="importData"
    confirmText="Save"
    size="lg"
    :displayOnRender="true"
    :dismiss="clearForm"
  >
    <div class="mt-4">
        <table v-tablesort class="dense mt-4">
            <thead>
              <tr>
                <td></td>
              <td>State</td>
              <td>Effective Date</td>
              <td>A/E</td>
              <td>Class Code</td>
              <td>Value</td>
              </tr>
            </thead>
            <tbody>
                <tr v-for="(x, index) in cleanExposures" :key="x.name">
                    <td>
                      <AppButton
                        variant="ghost"
                        size="icon"
                        :data-test="`${index}-delete-btn`"
                        @click="deletepayroll(index)"
                        class="delete-button">
                        <Trash2 :size="16" />
                      </AppButton>
                    </td>
                    <td>{{x.exposureAttributeEntries[0].value}}</td>
                    <td>{{filters.date(x.effectiveDate) }}</td>
                    <td>{{x.exposureAttributeEntries[2].value}}</td>
                    <td><TextField v-model="x.exposureAttributeEntries[1].value" :data-test="`${index}-code-text`" /></td>
                    <td><TextField v-model="x.value" :data-test="`${index}-value-text`" /></td>
                </tr>
            </tbody>
        </table>
        <ol class="error-list text-error" id="error-list">
          <li v-for="x in errorList" :key="x">{{x}}</li>
        </ol>
    </div>
</ConfirmModal>
</template>
<script>
import { Trash2 } from '@lucide/vue';
import ConfirmModal from './ConfirmModal.vue';
import AppButton from '@/components/v2/AppButton.vue';
import TextField from '@/components/v2/TextField.vue';
import { accountService } from '@/services/api';
import { filters } from '@/utilities/Filters';
export default {
  components: { ConfirmModal, Trash2, AppButton, TextField },
  props: {
    dirtyExposures: Array,
  },
  data() {
    return {
      filters,
      errorList: [],
      cleanExposures: [],
      };
  },
  
  methods: {
    async importData() {
      this.errorList = [];
      const escaped = this.cleanExposures.map(x => ({
        ...x,
        value: parseFloat(x.value.toString().replace(/[^0-9.-]+/g,''),''),
      }));
      
      const result = await accountService.validateExposures(escaped);
      
      if (result !== 'validation succeeded' ){
        document.getElementById('error-list').scrollIntoView({ behavior: 'smooth' });
        this.errorList = result.split(', ');
        return false;
      }

      await accountService.submitExposures(this.$route.params.id, escaped);
      
      this.$emit('uploadevent');
      return true;
    },
    deletepayroll(index) {
      this.cleanExposures.splice(index,1);
    },
    clearForm() {
      this.$emit('cancelevent');
    }
  },
  async created() {
    this.cleanExposures = this.dirtyExposures;
  }
};
</script>
<style scoped>
.error-list {
  list-style: decimal;
}
</style>
